// World Aquatics, February 2026, Part Two 4.1–4.3.
// These are practice timings/synthesized sounds, not prescribed competition timings.
export const RACE_DEFAULTS={raceProtocol:'forward',raceTiming:'fixed',raceHold:1.5,raceMin:1,raceMax:3,raceReady:5,raceEntry:5};
export const RACE_COMMAND='Take your marks.';
export function raceSettings(block){
  const c={...RACE_DEFAULTS};
  for(const key of Object.keys(c))if(block[key]!==undefined)c[key]=block[key];
  if(!['forward','backstroke','starter'].includes(c.raceProtocol))throw Error('Invalid race start procedure.');
  if(!['fixed','random'].includes(c.raceTiming))throw Error('Invalid race start delay mode.');
  for(const key of ['raceHold','raceMin','raceMax','raceReady','raceEntry']){
    if(!Number.isFinite(c[key])||c[key]<0||c[key]>(['raceReady','raceEntry'].includes(key)?60:10))throw Error('Invalid race start delay: use 0–10 seconds for the start hold and 0–60 seconds for preparation.');
  }
  if(c.raceMin>c.raceMax)throw Error('Race start minimum delay must not exceed the maximum.');
  if(block.raceSeed!==undefined&&(typeof block.raceSeed!=='string'||block.raceSeed.length>100))throw Error('Invalid race start random seed.');
  return c;
}
export function raceHold(block,occurrence){
  const c=raceSettings(block);
  if(c.raceTiming==='fixed')return c.raceHold;
  // Stable per occurrence across speech measurement, preview, export and reload.
  let hash=2166136261;
  for(const char of `${block.raceSeed??block.id}|${occurrence}`)hash=Math.imul(hash^char.charCodeAt(0),16777619)>>>0;
  return Math.max(c.raceMin,Math.min(c.raceMax,Math.round((c.raceMin+(c.raceMax-c.raceMin)*(hash/4294967295))*1000)/1000));
}
export function raceSequence(block,occurrence,commandDuration){
  const c=raceSettings(block),events=[];
  const whistle=(at,seconds)=>events.push({at,end:at+seconds,tone:2800,seconds,sound:'whistle',role:'cue'});
  let commandAt=0;
  if(c.raceProtocol!=='starter'){
    for(const at of [0,.3,.6])whistle(at,.12);
    whistle(1.2,1.2);commandAt=2.4+c.raceReady;
    if(c.raceProtocol==='backstroke'){
      // First long whistle invites entry; second calls swimmers to start position.
      whistle(2.4+c.raceEntry,1.2);commandAt=3.6+c.raceEntry+c.raceReady;
    }
  }
  events.push({at:commandAt,end:commandAt+commandDuration,clip:'tts:'+RACE_COMMAND,text:RACE_COMMAND,role:'instruction'});
  const hold=raceHold(block,occurrence),signalAt=commandAt+commandDuration+hold;
  events.push({at:signalAt,end:signalAt+.3,tone:1000,seconds:.3,sound:'start-signal',role:'cue'});
  return {events,hold,signalAt,seconds:signalAt+.3};
}
